import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const KEY = 'reviterReferralResellerId';
const TTL_MS = 7 * 24 * 60 * 60 * 1000; // 7 dias

// Captura `?ref=<userId>` da URL e persiste em localStorage com TTL.
// Chama `useReferralCapture()` uma vez no componente raiz (AppWrapper).
// `getReferralResellerId()` lê o valor válido pra incluir em createOrder.
export function useReferralCapture() {
  const { search } = useLocation();

  useEffect(() => {
    if (!search) return;
    const params = new URLSearchParams(search);
    const ref = params.get('ref');
    if (!ref || !/^\d+$/.test(ref)) return;
    try {
      localStorage.setItem(
        KEY,
        JSON.stringify({ id: parseInt(ref, 10), expiresAt: Date.now() + TTL_MS })
      );
    } catch {
      /* cookie/localStorage desabilitado — silenciar */
    }
  }, [search]);
}

export function getReferralResellerId() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.id || !parsed?.expiresAt) return null;
    if (Date.now() > parsed.expiresAt) {
      localStorage.removeItem(KEY);
      return null;
    }
    return parsed.id;
  } catch {
    return null;
  }
}

export function clearReferralResellerId() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* noop */
  }
}
